const routes = [
    {
        path: "/",
        name: "Retailer Home",
        component: () => import("@/views/retailer/Home/RetailerHome.vue"),
    },
    {
        path: "/retailer/list-of-products",
        name: "Product list",
        component: () => import("@/views/retailer/list-of-products/list.vue"),
    },
];

export default routes;
